import './accordion-title-amount.scss';
import React from 'react'

interface AccordionTitleAmountInterface {
  title?: string,
  description?: string,
}

const AccordionTitleAmount = ({ title = "", description = "", ...props }: AccordionTitleAmountInterface) => {
  
  return (
    <div className='polymer-accordion-title-amount'>
      <p>{title}</p>
      <p>{description}</p>
    </div>
  )
}

export default AccordionTitleAmount